import {useState} from 'react'
import type {CopilotReviewerRow} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import {normalizeCopilotReviewEffort, type CopilotReviewEffortValue} from './copilot-review-effort'

export function useStagedCopilotReviewEffort(row: CopilotReviewerRow | undefined, enabled = true) {
  const resolved = normalizeCopilotReviewEffort(row?.selectedReviewEffort)
  const [selection, setSelection] = useState<{
    resolved: CopilotReviewEffortValue | undefined
    enabled: boolean
    staged?: CopilotReviewEffortValue
  }>({resolved, enabled})
  if (selection.resolved !== resolved || selection.enabled !== enabled) {
    setSelection({resolved, enabled})
  }
  const stagedValue = selection.resolved === resolved && selection.enabled === enabled ? selection.staged : undefined
  return {
    shownEffort: stagedValue ?? resolved,
    explicitEffort: stagedValue,
    stageEffort: (value: CopilotReviewEffortValue) => setSelection({resolved, enabled, staged: value}),
  }
}
